'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BlogPage = () => {
  const navigate = useNavigate();
  const heroImage = `${process.env.PUBLIC_URL}/images/Hero/bloghero.webp`;

  const blogs = [
    {
      title: 'Undoing through the cracking concrete',
      date: 'December 24, 2025',
      image: `${process.env.PUBLIC_URL}/images/blogs/concretecracking/thumb.webp`,
      route: '/blogs/concrete-cracking',
    },
  ];

  return (
    <div className="bg-white text-black min-h-screen font-sans">
      <Navbar />

      {/* Hero Section */}
      <section
        id="hero"
        className="relative h-[60vh] flex flex-col justify-center items-center overflow-hidden bg-black"
      >
        <img
          src={heroImage}
          alt="Studio Journal Hero"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/45" />
      
        <motion.div
          className="relative z-10 text-center px-6 text-white"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
        >
          <h1 className="max-w-[92vw] text-center text-[clamp(2.5rem,10vw,7rem)] leading-[0.95] break-words font-heading font-light mb-4 tracking-wide">
            JOURNAL
          </h1>
        </motion.div>
      </section>


      {/* Blog Grid */}
      <section className="py-24 px-8 md:px-20 bg-gray-50">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-20">
          {blogs.map((blog, index) => (
            <motion.article
              key={index}
              onClick={() => navigate(blog.route)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && navigate(blog.route)}
              className="group cursor-pointer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.8 }}
            >
              {/* Image Plate */}
              <div className="relative aspect-[16/9] overflow-hidden rounded-none group-hover:rounded-2xl transition-all duration-500 ease-out">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-700 ease-out"
                />

                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-500" />
              </div>

              {/* Editorial Caption */}
              <div className="mt-4 space-y-1">
                <h3 className="text-base font-medium tracking-wide text-gray-900 leading-snug">
                  {blog.title}
                </h3>
                <p className="text-xs uppercase tracking-widest text-gray-500">
                  {blog.date}
                </p>
                <div className="h-[1px] w-12 bg-gray-300 mt-2 group-hover:w-24 transition-all duration-500" />
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
